import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';

const Counter = ({
  min = 0,
  max = 0,
  count = 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  handleChangeValue = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  handleClickDecrement = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  handleClickIncrement = () => {},
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Button
      data-cy="new-order_diet-length_counter-decrement"
      type="button"
      style={{
        width: '100%',
        maxWidth: '25px',
        height: '25px',
        padding: '3px 0 4px',
      }}
      onClick={handleClickDecrement}
      disabled={
        !(min === null || (min !== null && count - 1 >= min)) || count === 0
      }
    >
      -
    </Button>
    <CustomInput
      data-cy="new-order_diet-length_counter-input"
      type="number"
      noArrowsNumberInput={true}
      onClick={e => {
        e.stopPropagation();
      }}
      formControlProps={{
        fullWidth: true,
      }}
      inputProps={{
        value: count > 0 ? count : '',
        onChange: handleChangeValue,
        style: {
          margin: '0 10px',
          textAlign: 'center',
        },
      }}
    />
    <Button
      data-cy="new-order_diet-length_counter-increment"
      type="button"
      style={{
        width: '100%',
        maxWidth: '25px',
        height: '25px',
        padding: '3px 0 4px',
      }}
      onClick={handleClickIncrement}
      disabled={
        !(min === null || (min !== null && count + 1 <= max)) || count === 0
      }
    >
      +
    </Button>
  </div>
);

export default Counter;
